import { Box, Button } from "@pav/pav-products-design-system";
import React from "react";

const Navigation = ({
  steps,
  navigation,
  index,
  formData,
  submit,
  proceed,
  enrollmentFeeEnabled,
  acceptedEnrollmentFee,
}) => {
  const isLastStep = steps.length === index + 1;
  const hasPreviousButton = index > 0;
  const hasNextButton = steps.length > 1 && !isLastStep;
  const hasSubmitButton = steps.length === 1 || isLastStep;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        width: "100%",
        gap: "10px",
      }}
    >
      {hasPreviousButton && (
        <Box sx={{ display: "flex", flex: "1" }}>
          <Button
            fullWidth
            buttonType="primary"
            className="submit-button click-enroll-previous"
            onClick={navigation.previous}
          >
            PREVIOUS
          </Button>
        </Box>
      )}
      {hasNextButton && (
        <Box sx={{ display: "flex", marginTop: "32px", flex: "1" }}>
          <Button
            fullWidth
            type="submit"
            buttonType="primary"
            disabled={!proceed}
            className={
              proceed
                ? "submit-button click-enroll-next"
                : "submit-button disabled"
            }
          >
            Submit
          </Button>
        </Box>
      )}
      {hasSubmitButton && (
        <Box sx={{ display: "flex", flex: "1" }}>
          <Button
            fullWidth
            buttonType="primary"
            disabled={
              !proceed || (enrollmentFeeEnabled && !acceptedEnrollmentFee)
            }
            className={
              enrollmentFeeEnabled && !acceptedEnrollmentFee
                ? "submit-button disabled"
                : proceed
                  ? "submit-button click-enroll-submit"
                  : "submit-button disabled"
            }
            onClick={() => {
              submit(formData);
            }}
            padding="var(--spacing-lg)"
          >
            SUBMIT
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default Navigation;
